export type ResponseError = Error & {
  response: Response;
  responseBody?: unknown;
  status: number;
};

export const STANDARD_NEXT_FETCH_OPTIONS: NextFetchRequestConfig = {
  revalidate: 604800,
  tags: ["all"],
};

export async function fetcherWithResponse(
  ...[url, options = {}]: Parameters<typeof fetch>
) {
  // Disable caching by default. Matches Next 15 behavior.
  if (!options?.next?.revalidate) {
    options.next = options.next || {};
    options.next.revalidate = 0;
  }

  const response = await fetch(url, options);

  if (!response.ok) {
    const error = new Error(
      `Unable to fetch [${response.status}]: ${response.url}`,
    ) as ResponseError;

    error.status = response.status;
    error.response = response;

    try {
      error.responseBody = await response.json();
    } catch (e) {
      // No-op
    }

    throw error;
  }

  return response;
}

export async function fetcher<ResponseBody = any>(
  ...args: Parameters<typeof fetcherWithResponse>
) {
  const response = await fetcherWithResponse(...args);

  return (await response.json()) as ResponseBody;
}
